//
// Module for the Participant Communication's Contact Log Detail view
//
rs.module("content/participant/account/communications/contactlogdetail",

    ["common/select-helper" ],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {

            // Unpack Js Selectors
            var form = $.js(jsSelectors.form);

            var followUpCheckbox = form.js(jsSelectors.followUpCheckbox);
            var assignedToSelect = form.js(jsSelectors.assignedToSelect);

            // Get select helper(s)
            var assignedToSelectHelper = selectHelper.getHelper(assignedToSelect);

            // Unselect the assigned user when the follow up checkbox is unselected.
            followUpCheckbox.change(function () {
                if (!($(this).is(':checked'))) {
                    assignedToSelectHelper.setValue("");
                }
            });

            // Update the follow up checkbox based on selection
            assignedToSelect.change(function () {
                followUpCheckbox.setChecked(assignedToSelect.val() != '');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);